import * as React from 'react'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

const ErrorModal = ({ onClose }: { onClose: () => void }) => {
  return (
    <Modal
      illustration="alert"
      title={i18n.t('custom_reports.save_report_modal.error.title')}
      description={i18n.t('custom_reports.save_report_modal.error.description')}
      onClose={onClose}
    />
  )
}

export default observer(ErrorModal)
